import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1807.05882 C492.875294,1807.05882 112.941176,1427.12471 112.941176,960 C112.941176,492.875294 492.875294,112.941176 960,112.941176 C1427.12471,112.941176 1807.05882,492.875294 1807.05882,960 C1807.05882,1427.12471 1427.12471,1807.05882 960,1807.05882 M960,0 C430.644706,0 0,430.644706 0,960 C0,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,0 960,0 M790.588235,677.647059 L1162.50353,677.647059 L581.195294,1258.84235 L661.157647,1338.80471 L1242.35294,757.496471 L1242.35294,1129.41176 L1355.29412,1129.41176 L1355.29412,564.705882 L790.588235,564.705882 L790.588235,677.647059 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizStatsHighLine = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizStatsHighLine, _Component);

  var _super = _createSuper(IconQuizStatsHighLine);

  function IconQuizStatsHighLine() {
    _classCallCheck(this, IconQuizStatsHighLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizStatsHighLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuizStatsHigh",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconQuizStatsHighLine.displayName = "IconQuizStatsHighLine";
  return IconQuizStatsHighLine;
}(Component);

IconQuizStatsHighLine.glyphName = 'quiz-stats-high';
IconQuizStatsHighLine.variant = 'Line';
IconQuizStatsHighLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizStatsHighLine;
export { IconQuizStatsHighLine };